<app-menu-common url="sales"></app-menu-common>

<div class="bank-lettering-container">
  <!-- Top Page Header & Title Row -->
  <div class="pageheader flexcolumn">
    <div class="header-title-row">
      <div class="pagetitle-wrapper">
        <mat-icon class="pagetitle-icon">health_and_safety</mat-icon>
        <div>
          <div class="pagetitle grey">Rapprochement Bancaire FSE & Retours NOEMIE</div>
          <div class="pagesubtitle text-muted">Pointer les virements bancaires AMO/AMC et lettrer les créances tiers-payeurs (BOFIP ISCA)</div>
        </div>
      </div>
      <span class="spacer"></span>
      <div class="header-actions">
        <button mat-stroked-button color="primary" class="action-btn" (click)="activeTab === 'lettering' ? loadRspTransfers() : loadRspErrors()" [disabled]="isLoading" matTooltip="Rafraîchir les données">
          <mat-icon [class.spinning]="isLoading">refresh</mat-icon>
          Actualiser
        </button>
      </div>
    </div>

    <!-- Tabs Navigation Bar -->
    <div class="tabs-nav-bar">
      <button mat-button class="tab-nav-btn" [class.active]="activeTab === 'lettering'" (click)="selectTab('lettering')">
        <mat-icon>account_balance_wallet</mat-icon>
        <span>À rapprocher</span>
        <span class="badge-tab-count">{{ lots.length }}</span>
      </button>

      <button mat-button class="tab-nav-btn" [class.active]="activeTab === 'errors'" [class.has-errors]="errorLots.length > 0" (click)="selectTab('errors')">
        <mat-icon [class.text-warn]="errorLots.length > 0">warning</mat-icon>
        <span>Anomalies / Erreurs RSP</span>
        @if (errorLots.length > 0) {
          <span class="badge-tab-count error">{{ errorLots.length }}</span>
        }
      </button>
    </div>

    <!-- ================= TAB 1: LETTERING (3-ZONE GUI) ================= -->
    @if (activeTab === 'lettering') {
      <!-- Zone 1 : Saisie de l'encaissement bancaire -->
      <div class="statement-card">
        <div class="section-title">
          <mat-icon>payment</mat-icon>
          <span>Zone 1 : Saisie de la ligne bancaire / relevé</span>
        </div>
        <div class="filters-row">
          <!-- Date bancaire -->
          <div class="filter-item date-filter">
            <app-select-date
              label="Date de règlement"
              [date]="statement.dateReglement"
              (dateChange)="onDateChange($event)">
            </app-select-date>
          </div>
          <!-- Mode de règlement -->
          <div class="filter-item method-filter">
            <label class="filter-label">Mode de règlement</label>
            <select class="custom-select" [(ngModel)]="statement.paymentMethod">
              <option [ngValue]="6">Virement</option>
              <option [ngValue]="1">Carte bancaire</option>
              <option [ngValue]="3">Chèque</option>
            </select>
          </div>
          <!-- Référence relevé / virement -->
          <div class="filter-item ref-filter">
            <label class="filter-label">Référence virement / pièce</label>
            <input
              type="text"
              class="custom-input"
              placeholder="Ex: VIR-CPAM-751-20260731..."
              [(ngModel)]="statement.bankReference" />
          </div>
          <!-- Compte / IBAN bancaire -->
          <div class="filter-item iban-filter">
            <label class="filter-label">Compte bancaire / IBAN (optionnel)</label>
            <input
              type="text"
              class="custom-input"
              placeholder="Ex: FR76 3000 4000..."
              [(ngModel)]="statement.bankAccount" />
          </div>
          <!-- Montant total encaissé -->
          <div class="filter-item amount-filter">
            <label class="filter-label highlight-label">Montant encaissé relevé (€)</label>
            <div class="amount-input-wrapper">
              <input
                type="number"
                step="0.01"
                min="0.01"
                class="custom-input amount-input"
                placeholder="0.00"
                [(ngModel)]="statement.totalAmount" />
              <span class="currency-symbol">€</span>
            </div>
          </div>
        </div>
        <!-- Note / Commentaire -->
        <div class="statement-footer-row">
          <div class="filter-item full-width">
            <label class="filter-label">Note / Motif du lettrage (optionnel)</label>
            <input
              type="text"
              class="custom-input"
              placeholder="Commentaire interne pour la piste d'audit..."
              [(ngModel)]="statement.note" />
          </div>
        </div>
      </div>
    }
  </div>

  <!-- ================= TAB 1: LETTERING (KPI & TABLE) ================= -->
  @if (activeTab === 'lettering') {
    <!-- Zone 3 : Contrôle d'équilibrage en temps réel (KPI Banner & Action Bar) -->
    <div class="kpi-banner">
      <!-- Card 1 : Montant bancaire saisi -->
      <div class="kpi-card">
        <div class="kpi-icon-wrapper purple">
          <mat-icon>account_balance_wallet</mat-icon>
        </div>
        <div class="kpi-content">
          <div class="kpi-value">{{ (statement.totalAmount || 0) | number:'1.2-2' }} €</div>
          <div class="kpi-label">Montant Relevé Saisi</div>
        </div>
      </div>
      <!-- Card 2 : Total alloué aux virements tiers-payeurs -->
      <div class="kpi-card">
        <div class="kpi-icon-wrapper blue">
          <mat-icon>playlist_add_check</mat-icon>
        </div>
        <div class="kpi-content">
          <div class="kpi-value">{{ getTotalAllocated() | number:'1.2-2' }} €</div>
          <div class="kpi-label">Total Imputé ({{ selectedPaymentIds.size }} virement{{ selectedPaymentIds.size > 1 ? 's' : '' }})</div>
        </div>
      </div>
      <!-- Card 3 : Écart d'équilibrage -->
      <div class="kpi-card" [class.highlight-balanced]="isBalanced()" [class.highlight-imbalance]="!isBalanced() && (statement.totalAmount || 0) > 0">
        <div class="kpi-icon-wrapper" [ngClass]="isBalanced() ? 'green' : 'red'">
          <mat-icon>{{ isBalanced() ? 'check_circle' : 'balance' }}</mat-icon>
        </div>
        <div class="kpi-content">
          <div class="kpi-value" [ngClass]="isBalanced() ? 'success-text' : 'due-alert'">
            {{ getBalanceDifference() | number:'1.2-2' }} €
          </div>
          <div class="kpi-label">
            {{ isBalanced() ? 'Équilibré (0,00 €) - Prêt à valider' : (getBalanceDifference() > 0 ? 'Reste à imputer sur virements' : 'Dépassement du montant bancaire') }}
          </div>
        </div>
      </div>
      <!-- Card 4 : Validation & Déclenchement Scellement BOFIP -->
      <div class="kpi-card validation-card">
        <div class="validation-content">
          <button
            mat-flat-button
            color="primary"
            class="validate-button"
            (click)="onSubmitLettering()"
            [disabled]="!isBalanced() || isSubmitting">
            <mat-icon>lock</mat-icon>
            <span>Valider et sceller BOFIP</span>
          </button>
          @if (!isBalanced()) {
            <div class="validation-hint">
              @if ((statement.totalAmount || 0) <= 0) {
                <span>Saisir le montant bancaire</span>
              }
              @if ((statement.totalAmount || 0) > 0 && selectedPaymentIds.size === 0) {
                <span>Sélectionner des virements FSE</span>
              }
              @if ((statement.totalAmount || 0) > 0 && selectedPaymentIds.size > 0 && getBalanceDifference() !== 0) {
                <span>
                  Ajuster pour atteindre 0,00 € d'écart
                </span>
              }
            </div>
          }
          @if (isBalanced()) {
            <div class="validation-hint success">
              <span>Équilibrage parfait : prêt au scellement fiscal</span>
            </div>
          }
        </div>
      </div>
    </div>
    <!-- Zone 2 : Table des règlements tiers-payeurs ouverts -->
    <div class="table-card">
      <div class="table-header-bar">
        <div class="table-title">
          <mat-icon>list_alt</mat-icon>
          <span>Zone 2 : Sélection des virements tiers-payeurs à lettrer</span>
          <span class="badge-count">{{ filteredLots.length }} virement{{ filteredLots.length > 1 ? 's' : '' }}</span>
        </div>
        <!-- Quick Filters -->
        <div class="table-filters-inline">
          <!-- Part Type filter -->
          <div class="filter-item-inline">
            <select class="custom-select small-select" [(ngModel)]="filter.partFilter">
              <option value="ALL">Toutes les parts (AMO + AMC)</option>
              <option value="AMO">Part AMO (Sécurité Sociale)</option>
              <option value="AMC">Part AMC (Mutuelle)</option>
            </select>
          </div>
          <!-- Search query -->
          <div class="filter-item-inline search-box">
            <input
              type="text"
              class="custom-input small-input"
              placeholder="Filtrer FSE, patient, sécu, organisme, virement..."
              [(ngModel)]="filter.search" />
            @if (filter.search) {
              <button mat-icon-button (click)="filter.search = ''" class="clear-btn">
                <mat-icon>close</mat-icon>
              </button>
            }
          </div>
          <button mat-stroked-button (click)="onResetFilters()" [disabled]="isLoading" class="btn-reset-inline" matTooltip="Réinitialiser filtres">
            <mat-icon>clear</mat-icon>
          </button>
          <span class="spacer"></span>
          <!-- Batch Selection Actions -->
          <div class="batch-actions">
            <button mat-button color="primary" (click)="selectAllPayments()" [disabled]="filteredLots.length === 0">
              <mat-icon>select_all</mat-icon>
              Tout sélectionner
            </button>
            <button mat-button (click)="deselectAllPayments()" [disabled]="selectedPaymentIds.size === 0">
              <mat-icon>deselect</mat-icon>
              Désélectionner
            </button>
          </div>
        </div>
      </div>
      <!-- Loading State -->
      @if (isLoading) {
        <div class="loading-state">
          <mat-spinner diameter="40"></mat-spinner>
          <span>Chargement des règlements ouverts...</span>
        </div>
      }
      <!-- Empty State -->
      @if (!isLoading && lots.length === 0) {
        <div class="empty-state">
          <mat-icon class="empty-icon">task_alt</mat-icon>
          <div class="empty-title">Aucun virement tiers-payeur en attente</div>
          <div class="empty-desc">Tous les règlements AMO et AMC ont été pointés et lettrés.</div>
        </div>
      }
      <!-- Filtered Empty State -->
      @if (!isLoading && lots.length > 0 && filteredLots.length === 0) {
        <div class="empty-state">
          <mat-icon class="empty-icon">filter_alt_off</mat-icon>
          <div class="empty-title">Aucun résultat pour ce filtre</div>
          <div class="empty-desc">Modifiez vos critères de recherche pour afficher les règlements.</div>
        </div>
      }
      <!-- Payments Table -->
      @if (!isLoading && filteredLots.length > 0) {
        <div class="table-responsive">
          <table class="lettering-table">
            <thead>
              <tr>
                <th class="col-checkbox text-center">
                  <mat-icon class="th-icon">check_box</mat-icon>
                </th>
                <th class="col-date">Date Valeur</th>
                <th class="col-part text-center">Part</th>
                <th class="col-payer">Organisme Payeur</th>
                <th class="col-patient">Bénéficiaire</th>
                <th class="col-fse text-center">N° FSE</th>
                <th class="col-ref">Libellé Virement</th>
                <th class="col-expected text-right">Montant Attendu</th>
                <th class="col-allocated text-right">Montant à Lettrer (€)</th>
              </tr>
            </thead>
            <tbody>
              @for (lot of filteredLots; track lot) {
                <tr
                  [class.row-selected]="isPaymentSelected(lot.paymentId)"
                  (click)="togglePaymentSelection(lot)"
                  class="clickable-row">
                  <!-- Checkbox -->
                  <td class="col-checkbox text-center" (click)="$event.stopPropagation()">
                    <mat-checkbox
                      [checked]="isPaymentSelected(lot.paymentId)"
                      (change)="togglePaymentSelection(lot)"
                      color="primary">
                    </mat-checkbox>
                  </td>
                  <!-- Date Valeur -->
                  <td class="col-date">
                    <span class="cell-date">{{ lot.dateComptable | date:'dd/MM/yyyy' }}</span>
                  </td>
                  <!-- Part (AMO / AMC badge) -->
                  <td class="col-part text-center">
                    <span class="badge-payer" [class.badge-amo]="lot.partType === 'AMO'" [class.badge-amc]="lot.partType === 'AMC'">
                      {{ lot.partType }}
                    </span>
                  </td>
                  <!-- Organisme Payeur -->
                  <td class="col-payer">
                    <div class="cell-main-text">{{ lot.payerName }}</div>
                    @if (lot.organismCode) {
                      <div class="cell-sub-text font-mono">{{ lot.organismCode }}</div>
                    }
                  </td>
                  <!-- Bénéficiaire -->
                  <td class="col-patient">
                    <div class="cell-main-text">{{ lot.patientName }}</div>
                    @if (lot.numSecu) {
                      <div class="cell-sub-text font-mono">{{ lot.numSecu }}</div>
                    }
                  </td>
                  <!-- N° FSE -->
                  <td class="col-fse text-center">
                    <span class="badge-fse font-mono">{{ lot.fseNumber }}</span>
                  </td>
                  <!-- Libellé Virement -->
                  <td class="col-ref">
                    <div class="cell-main-text">{{ lot.libVirement }}</div>
                    @if (lot.libVirement2) {
                      <div class="cell-sub-text">{{ lot.libVirement2 }}</div>
                    }
                  </td>
                  <!-- Montant Attendu -->
                  <td class="col-expected text-right">
                    <span class="amount-expected font-mono">{{ lot.amount | number:'1.2-2' }} €</span>
                  </td>
                  <!-- Montant à Lettrer Input -->
                  <td class="col-allocated text-right" (click)="$event.stopPropagation()">
                    <div class="allocated-input-box" [class.active-allocation]="isPaymentSelected(lot.paymentId)">
                      <input
                        type="number"
                        step="0.01"
                        min="0"
                        class="custom-input inline-amount-input font-mono"
                        [value]="isPaymentSelected(lot.paymentId) ? getAllocatedAmount(lot.paymentId) : ''"
                        [placeholder]="lot.amount | number:'1.2-2'"
                        (input)="onAllocatedAmountChange(lot, $event)" />
                      <span class="input-currency">€</span>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </div>
  }

  <!-- ================= TAB 2: ANOMALIES & ERREURS RSP ================= -->
  @if (activeTab === 'errors') {
    <div class="panels-layout" style="margin-top: 8px;">
      <!-- LEFT PANEL: List of RSPs in ERROR state -->
      <div class="panel-card left-panel">
        <div class="panel-header">
          <div class="panel-title">
            <mat-icon class="text-warn">warning</mat-icon>
            <span>RSPs en Erreur de Traitement</span>
            <span class="badge-count error">{{ errorLots.length }}</span>
          </div>
          <span class="spacer"></span>
          <button mat-stroked-button color="primary" class="action-btn" (click)="onRetryLettering()">
            <mat-icon>autorenew</mat-icon>
            Relancer le lettrage
          </button>
        </div>
        @if (errorLots.length === 0) {
          <div class="empty-panel-state">
            <mat-icon class="empty-icon-success">check_circle</mat-icon>
            <div class="empty-title">Aucune anomalie RSP détectée</div>
            <div class="empty-desc">Toutes les données RSP reçues ont été traitées ou attribuées avec succès.</div>
          </div>
        }
        @if (errorLots.length > 0) {
          <div class="table-responsive">
            <table class="modern-table">
              <thead>
                <tr>
                  <th>Date Valeur</th>
                  <th>N° Facture</th>
                  <th>Payeur</th>
                  <th>Diagnostic Erreur</th>
                  <th class="text-right">Montant</th>
                </tr>
              </thead>
              <tbody>
                @for (element of errorLots; track element) {
                  <tr
                    [class.selected-row]="selectedErrorRsp?.id === element.id"
                    (click)="selectErrorRsp(element)"
                    class="clickable-row">
                    <td>{{ element.dateComptable | date: 'dd/MM/yyyy' }}</td>
                    <td><span class="fse-num-text">{{ element.numFacture }}</span></td>
                    <td>{{ element.typeEmetFic }}-{{ element.numEmetFic }}</td>
                    <td>
                      <div class="error-cell-text">
                        {{ element.data.error || 'Erreur lors du traitement' }}
                      </div>
                    </td>
                    <td class="text-right font-mono font-amount">
                      {{ element.data.totalPaiement | fcfse }}
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
      </div>
      <!-- RIGHT PANEL: Diagnostic Panel for selected ERROR RSP -->
      @if (selectedErrorRsp) {
        <div class="panel-card right-panel">
          <div class="panel-header">
            <div class="panel-title">
              <mat-icon class="text-warn">bug_report</mat-icon>
              <span>Diagnostic & Résolution d'Anomalie</span>
            </div>
          </div>
          <!-- Error Banner Callout -->
          <div class="error-banner-callout">
            <div class="error-banner-header">
              <mat-icon>error_outline</mat-icon>
              <span>Erreur de Lettrage</span>
            </div>
            <p class="error-banner-desc">
              {{ selectedErrorRsp.data.error || 'Erreur indéterminée lors du lettrage automatique de cet RSP.' }}
            </p>
          </div>
          <!-- RSP Technical Specs Card -->
          <div class="rsp-summary-box error-box">
            <div class="summary-line">
              <span class="label">N° Facture FSE :</span>
              <span class="value">{{ selectedErrorRsp.numFacture }}</span>
            </div>
            <div class="summary-line">
              <span class="label">Libellé virement :</span>
              <span class="value">{{ selectedErrorRsp.data.libVirement1 }}</span>
            </div>
            <div class="summary-line">
              <span class="label">Organisme Émetteur :</span>
              <span class="value">{{ selectedErrorRsp.typeEmetFic }}-{{ selectedErrorRsp.numEmetFic }}</span>
            </div>
            <div class="summary-line">
              <span class="label">Date comptable :</span>
              <span class="value">{{ selectedErrorRsp.dateComptable | date: 'dd/MM/yyyy' }}</span>
            </div>
            @if (selectedErrorRsp.numSecu) {
              <div class="summary-line">
                <span class="label">N° Sécurité Sociale :</span>
                <span class="value">{{ selectedErrorRsp.numSecu }}</span>
              </div>
            }
            @if (selectedErrorRsp.data.nomBenef) {
              <div class="summary-line">
                <span class="label">Bénéficiaire :</span>
                <span class="value">{{ selectedErrorRsp.data.nomBenef }} {{ selectedErrorRsp.data.prenomBenef }}</span>
              </div>
            }
            <div class="summary-line highlight-line">
              <span class="label">Montant RSP :</span>
              <span class="value amount-highlight text-warn">{{ selectedErrorRsp.data.totalPaiement | fcfse }} €</span>
            </div>
          </div>
          <!-- Action Section -->
          <div class="resolution-actions-box">
            <p class="resolution-hint">
              Après avoir vérifié et corrigé la cause de l'erreur (ex : ajout du rôle AMO/AMC à l'organisme, paramétrage régime/caisse), cliquez ci-dessous pour relancer le lettrage de tous les RSP en attente.
            </p>
            <button mat-flat-button color="primary" class="full-width-btn" (click)="onRetryLettering()">
              <mat-icon>autorenew</mat-icon>
              Relancer le lettrage des RSP
            </button>
          </div>
        </div>
      }
      <!-- Empty Selection State (Right Panel Errors) -->
      @if (!selectedErrorRsp) {
        <div class="panel-card right-panel empty-selection-panel">
          <mat-icon class="placeholder-icon">bug_report</mat-icon>
          <p class="placeholder-text">Sélectionnez une anomalie RSP à gauche pour visualiser les détails du diagnostic.</p>
        </div>
      }
    </div>
  }
</div>